
import "./sign_up_page.css";
import NavbarLogin from "../../../components/nav/nav_login";
import AboutContainer from "../../../components/home/about/about";
import { useNavigate, useLocation,useSearchParams  } from "react-router-dom";
import { useState, useEffect } from "react";
import NavbarSignUpLogin from "../../../components/nav/nav_login_signup_login";
import ProfileForm from "../profile/profile_form";
import TypeButtons from "../type/type";
import LegalDocuments from "../legal/legal";
import { fetchItems,createItem } from "../../../api/networking";
import { FaChevronRight } from "react-icons/fa6";
import { motion, AnimatePresence } from "framer-motion";



const SignUpPageMain = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const fromSignup = location.state?.fromSignup;
    const [searchParams] = useSearchParams();
    const fromSignup2 = searchParams.get('fromSignup') === 'true';
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [firstname, setFirstname] = useState();
    const [lastname, setLastName] = useState();
    const [accountType, setAccounType] = useState();
    const [error, setError] = useState("");
    const [listOfErrors, SetListOfErrors] = useState([])
    const [pages, setPages] = useState([true,false,false]);
    const [currentPageNumber, setCurrentPageNumber] = useState(0);
    const [agreed, setAgreed] = useState(false);
    const [isPrivacy, setIsPrivacy] = useState(false);
    const [isTerms, setIsTerms] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [isError, setIsError] = useState([false,false,false])


    const errors = () => {
        const tempIsError = [false, false, false];


        if(email == undefined || firstname == undefined || lastname == undefined || password == undefined || email == " " || firstname == " " || lastname == " " || password == " "){
            tempIsError[0]= true;
        }

        if(password != undefined){
            if(password.length < 8){
                tempIsError[0]= true;
            }
        }

        if(accountType == "" || accountType == undefined){
            tempIsError[1]= true;
        }


        if(isPrivacy == false || isTerms == false){
            tempIsError[2]= true;
        }

        setIsError(tempIsError);
        console.log("Account Type: ", email)
        console.log("Errors: ", tempIsError)

    }


  const  handleCreateAccount = async() => {

    if(email == "" || firstname == "" || lastname == "" || password == "" || email == undefined || firstname == undefined || lastname == undefined || password == undefined || accountType == "" || isPrivacy == false || isTerms == false){
        errors();
    }else{
        //e.preventDefault();
        // TODO: Replace with real auth logic
        if(password != undefined){
            if (password.length < 8) {
                errors();
                return;
                }
        
        }

        try{
        const response = await createItem('/v1/users/createAccount',{ email, firstname,lastname, password, account_type: accountType, term_privacy_check: agreed });
        if(response[0] == 200){

            navigate("/api-dashboard", { state: { isAdmin: false, email:email, initials: (firstname[0]+lastname[0]).toUpperCase()} });
            //navigate("/dashboard");
        }
        }catch(e){
        console.log("Error: ",e.status)
        console.log("Error: ",e.code)
        setError("Invalid email or password.");
        }
    }


  };

    const pageVariants = {
        initial: {
        x: 40,
        opacity: 0
        },
        animate: {
        x: 0,
        opacity: 1
        },
        exit: {
        x: 0,
        opacity: 0
        }
    };


    const onClickPageChange = (item) => {
        let page = [false,false,false];
        switch(item){
            case 0:
                page = [true,false,false];
                setCurrentPageNumber(0)
                break;
            case 1:
                page = [false,true,false];
                setCurrentPageNumber(1)
                break;
            case 2:
                page = [false,false,true];
                setCurrentPageNumber(2)
                break;
            default:
                page = [true,false,false];
                setCurrentPageNumber(0)

        }
        setPages(page);

    }

    const incrementPageChange = () => {

        if(pages[0]){
            const page = [false,true,false];
            setPages(page);
        }else if(pages[1]){
            const page = [false,false,true];
            setPages(page);
        }else if(pages[2]){

        }

        console.log("Number Of pages",currentPageNumber);
        console.log("Number Of pages",pages.length);

        if(currentPageNumber <= pages.length-2){
            setCurrentPageNumber(prev => prev + 1)
        }else{
            handleCreateAccount();
            //setShowModal(true)
        }
    }


    useEffect(()=>{
        console.log("current Page",location.pathname); 
    });




  
    return (
    <div className="loginpage-whole-outer">
                    <div className="left-column">
                        <NavbarLogin/>


                        <div className="signup-form-container">
                                <div className="signup_total">

                                    <div className="signup_form_page_body_svg">
                                        <div className="side_nav_container">
                                            <div className={
                                                currentPageNumber ==0
                                                ?"side_nav_container_item-active"
                                                :"side_nav_container_item"}>Profile</div>
                                            <button className={
                                                currentPageNumber ==0
                                                ?"side_nav_button_active side_nav_container_item"
                                                :"side_nav_button side_nav_container_item"} onClick={() => onClickPageChange(0)}></button> 
                                        </div>
                                        <div className="side_nav_container">
                                            <div className={
                                                currentPageNumber ==1?
                                                "side_nav_container_item-active"
                                                :"side_nav_container_item"}>Type</div>
                                            <button  className={
                                                currentPageNumber ==1
                                                ?"side_nav_button_active side_nav_container_item"
                                                :"side_nav_button side_nav_container_item"} onClick={() => onClickPageChange(1)}></button>
                                        </div>
                                        <div className="side_nav_container">
                                            <div className={
                                                currentPageNumber ==2
                                                ?"side_nav_container_item-active":
                                                "side_nav_container_item"}>Legal</div>
                                            <button  className={
                                                currentPageNumber ==2
                                                ?"side_nav_button_active side_nav_container_item"
                                                :"side_nav_button side_nav_container_item"}  onClick={() => onClickPageChange(2)}></button>
                                        </div>
                                    </div>

                                    <div className="signup_form_page_title">
                                        <h2 className="title">Get Started!</h2>
                                        <p className="sub_title">Lets create your account</p>
                                        <div className="signup_form_page_body_form">
                                                {pages[0] && 
                                                <motion.div
                                                key="profile"
                                                variants={pageVariants}
                                                initial="initial"
                                                animate="animate"
                                                exit="exit"
                                                transition={{ duration: 0.40 }}
                                                >
                                                    <ProfileForm 
                                                    isErrors={isError}
                                                    email={email}
                                                    setEmail={setEmail}
                                                    firstName={firstname}
                                                    setFirstName={setFirstname}
                                                    lastName={lastname}
                                                    setLastName={setLastName}
                                                    password ={password}
                                                    setPassword ={setPassword}
                                                    />
                                                </motion.div>}

                                                {pages[1] &&
                                                
                                                <motion.div
                                                key="accounttype"
                                                variants={pageVariants}
                                                initial="initial"
                                                animate="animate"
                                                exit="exit"
                                                transition={{ duration: 0.40 }}
                                                ><TypeButtons
                                                isErrors={isError}
                                                accountTypeString={accountType}
                                                setAccountTypeString={setAccounType}
                                                /></motion.div>}
                                                {pages[2] &&
                                                
                                                <motion.div
                                                key="legal"
                                                variants={pageVariants}
                                                initial="initial"
                                                animate="animate"
                                                exit="exit"
                                                transition={{ duration: 0.40 }}
                                                ><LegalDocuments 
                                                isErrors={isError}
                                                isViewedPrivacy={isPrivacy}
                                                isViewedTerms={isTerms}
                                                setIsViewedTerms={setIsTerms}
                                                setIsViewedPrivacy={setIsPrivacy}
                                                isLegalAgree={agreed}
                                                setIsLegalAgree={setAgreed}
                                                /></motion.div>}
                                        </div>
                                    </div>              

                                </div>
                                
                        </div>
                        <div className="bottom_button_container">
                            <button onClick={incrementPageChange} className="bottom_button"><FaChevronRight  size={24}/></button>
                        </div>

                    </div>
                    <div className="right-column">
                        <NavbarSignUpLogin/>
                    </div>
                    {showModal && (
                        <div className="modal-overlay">
                            <div className="modal-container">
                            <button 
                                className="modal-close"
                                onClick={() => setShowModal(false)}
                            >
                                X
                            </button>

                            <h2>Errors</h2>
                            <p>
                                Your privacy policy content goes here...
                            </p>

                            </div>
                        </div>
                        )}
      </div>
    );
  };
  
  export default SignUpPageMain;